var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgClose = function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m11.41 10 8.29-8.29A1 1 0 0 0 18.29.29L10 8.59 1.71.29A1 1 0 0 0 .29 1.71L8.59 10l-8.3 8.29A1 1 0 1 0 1.7 19.7l8.3-8.29 8.29 8.29a1 1 0 0 0 1.41-1.41Z"
  })));
};
export default SvgClose;